module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/noimage-c6846ae02d99ca4addc2f34a7b845e5f.png";